// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"72529ce5","977":"ef11f6e3"}[chunkId] + ".chunk.js";
};